"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importFile = exports.serialise = exports.exportFile = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var LINE_BREAK = '\r\n';
/**
 * Will open a web browser download csv file dialog. Data should be serialised beforehand (see serialise function)
 * @param data already serialised in string format.
 * @param filename the name of the csv file which will be downloaded.
 */
function exportFile(data, filename) {
    var a = document.createElement('a');
    var blob = new Blob([data], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    var isIE = /*@cc_on!@*/ !!document.documentMode;
    if (isIE) {
        navigator === null || navigator === void 0 ? void 0 : navigator.msSaveBlob(blob, filename + '.csv');
    }
    else {
        a.download = filename + '.csv';
        a.click();
    }
}
exports.exportFile = exportFile;
/**
 * Returns a string of comma separated values including line breaks for a supplied array of objects.
 * @param rows Array of objects. Should be of uniform number of keys. Values should be of primitive type.
 */
function serialise(rows) {
    if (rows.length === 0) {
        console.warn('No data to serialise');
        return '';
    }
    var headers = Object.keys(rows[0]);
    var meta = rows.map(function (row) {
        var keys = Object.keys(row);
        var values = keys.map(function (key) { return row[key]; });
        var pairs = keys.map(function (key) { return ({ key: key, value: row[key] }); });
        return { row: row, keys: keys, values: values, pairs: pairs };
    });
    if (meta.some(function (_a) {
        var keys = _a.keys;
        return !isMatch(keys, headers);
    })) {
        console.warn('Mismatching headers in exported CSV data', rows);
        meta.forEach(function (exploded) {
            exploded.values = exploded.pairs.filter(function (_a) {
                var key = _a.key;
                return headers.indexOf(key) > -1;
            }).map(function (_a) {
                var value = _a.value;
                return value;
            });
        });
    }
    return meta.reduce(function (aggregate, _a) {
        var values = _a.values;
        return "".concat(aggregate, "\"").concat(values.join('","'), "\"").concat(LINE_BREAK);
    }, "\"".concat(headers.join('","'), "\"").concat(LINE_BREAK));
}
exports.serialise = serialise;
function importFile(blob) {
    var subject = new rxjs_1.Subject();
    readFile(blob)
        .pipe((0, operators_1.catchError)(function (err) {
        console.log('There has been an error in reading this file: ', err);
        return (0, rxjs_1.throwError)(err);
    }))
        .subscribe(function (output) {
        var allLines = output.split('\n');
        var lines = allLines.filter(function (row) { return row.length > 2; });
        var headersLine = lines[0].split(',');
        var headers = headersLine.map(function (header) { return header.trim(); });
        var rows = [];
        for (var i = 1; i < lines.length; i++) {
            var rowObject = {};
            var currentLine = lines[i].split(',');
            for (var j = 0; j < headers.length; j++) {
                rowObject[headers[j].replace(/\"/g, '')] = currentLine[j].replace(/\"/g, '');
            }
            rows.push(rowObject);
        }
        subject.next(rows);
    }, function (error) {
        console.log('common-utils error', error.name + ': ' + error.message);
    });
    return subject.asObservable();
}
exports.importFile = importFile;
function readFile(blob) {
    var reader = new FileReader();
    var sub = new rxjs_1.Subject();
    // This fires after the blob has been read/loaded.
    reader.onload = function () {
        var content = reader.result;
        sub.next(content);
        sub.complete();
    };
    // Start reading the blob as text.
    reader.readAsText(blob);
    return sub.asObservable();
}
function isMatch(a, b) {
    var inclusive = a.length === b.length;
    var exclusive = function () { return a.every(function (d) { return b.indexOf(d) > -1; }); };
    return inclusive && exclusive(); // using function to avoid evaluating exclusive unnecessarily
}
